import { MONTHLY } from '~/constants/dateDurations';
import { PaymentPlanType, SectionsEnum } from '~/types/listingTypes';

export const isMonthlyRentalPlan = (duration: number) => {
  const totalDays = Math.max(Math.floor(duration), 0);
  return totalDays === MONTHLY;
};

const hasOnlyMonthlyRentalPlans = (plans: PaymentPlanType[]) =>
  plans.length === 1 && isMonthlyRentalPlan(plans[0].duration);

export const getRentalPlanDetails = ({
  plans,
  section,
}: {
  plans?: PaymentPlanType[];
  section?: string;
}) => {
  if (!plans || plans.length === 0 || !section) return null;

  const hasRentalValues =
    section === SectionsEnum.FOR_RENT && plans?.length > 0;
  const hasOnlyMonthlyPlans =
    hasRentalValues && hasOnlyMonthlyRentalPlans(plans);
  const hasRentalPlans = hasRentalValues && !hasOnlyMonthlyPlans;

  return {
    hasRentalPlans,
    hasOnlyMonthlyPlans,
  };
};

export default getRentalPlanDetails;
